// src/components/familytree/LinkConfirmationModal.js
// Updated: 10/17/2025 02:25 PM

import React from 'react';
import ModalWrapper from '../common/ModalWrapper';

const LinkConfirmationModal = ({ source, target, onConfirm, onCancel }) => {
  const handleConfirm = (relationship) => {
    onConfirm(source, target, relationship);
  };

  return (
    <ModalWrapper onClose={onCancel} size="md">
      <div className="p-6">
        <h3 className="text-lg font-medium text-gray-900">Create a Relationship</h3>
        <p className="mt-2 text-sm text-gray-500">How is <strong>{source.firstName} {source.lastName}</strong> related to <strong>{target.firstName} {target.lastName}</strong>?</p>
      </div>
      <div className="p-6 space-y-3">
        <button
          onClick={() => handleConfirm('parent')}
          className="w-full text-left p-3 border rounded-md hover:bg-gray-100 transition-colors"
        >
          <strong>{source.firstName}</strong> is the Parent of <strong>{target.firstName}</strong>
        </button>
        <button
          onClick={() => handleConfirm('spouse')}
          className="w-full text-left p-3 border rounded-md hover:bg-gray-100 transition-colors"
        >
          <strong>{source.firstName}</strong> is the Spouse of <strong>{target.firstName}</strong>
        </button>
      </div>
      <div className="p-4 bg-gray-50 flex justify-end">
        <button onClick={onCancel} className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50">Cancel</button>
      </div>
    </ModalWrapper>
  );
};

export default LinkConfirmationModal;